import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input"];

  onHashChange() {
    this.inputTarget.value = window.location.href;
  }
}
